// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__24YKO","question":"Question_question__1xBHC","description":"Question_description__2nW0Q"};